const getVideo = (id) => (
  `https://i.giphy.com/media/${id}/giphy.mp4`
);

export default getVideo;
